import { render, staticRenderFns } from "./WallCotent.vue?vue&type=template&id=1586f5dc&scoped=true&"
import script from "./WallCotent.vue?vue&type=script&lang=js&"
export * from "./WallCotent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1586f5dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1586f5dc')) {
      api.createRecord('1586f5dc', component.options)
    } else {
      api.reload('1586f5dc', component.options)
    }
    module.hot.accept("./WallCotent.vue?vue&type=template&id=1586f5dc&scoped=true&", function () {
      api.rerender('1586f5dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/view-report/components/WallCotent.vue"
export default component.exports